import { Controller, useFormContext } from 'react-hook-form';
import ListSelector from './ListSelector';

export default function ListSelectorField({
    gridColumns,
    selectedGridColumns,
    dbSelected,
    fieldName,
    selectedDataSource,
    selectedLoaderFunction,
    availableDataSource,
    availableLoaderFunction,
    availableSelectAll,
    idsDataSource,
    addButtonText,
    removeButtonText,
    sorters,
    setSelectionIsDirty,
    isMultiRemove,
    selectedEmptyGridText,
    updateSelectionFunction,
    resolveInvertedFunction,
    disabled = false,
    // If a non null values exists for dataArray, array loader will be used
    // to build the selector using the static values in this array.
    dataArray = null,
    // Static data array field that you want to allow the user to search against
    dataArraySearchFields = [],
    // Hides the action buttons if true
    hideActions = false,
    // If this is present, and it resolves to false, the row will not be removable from the table.
    // This is useful in situations where a selector should have some set of permanent data.
    rowRemovalCondition,
    visibleRows = undefined,
    // Hides CSV export button
    disableCSVExport = true,
    onAddAction,
    dialogMaxWidth,
    dialogFullWidth,
}) {
    const { control } = useFormContext();

    return (
        <Controller
            control={control}
            name={fieldName}
            defaultValue={[]}
            render={() => (
                <ListSelector
                    gridColumns={gridColumns}
                    selectedGridColumns={selectedGridColumns}
                    dbSelected={dbSelected}
                    selectedDataSource={selectedDataSource}
                    selectedLoaderFunction={selectedLoaderFunction}
                    availableDataSource={availableDataSource}
                    availableLoaderFunction={availableLoaderFunction}
                    availableSelectAll={availableSelectAll}
                    idsDataSource={idsDataSource}
                    fieldName={fieldName}
                    addButtonText={addButtonText}
                    removeButtonText={removeButtonText}
                    sorters={sorters}
                    setSelectionIsDirty={setSelectionIsDirty}
                    isMultiRemove={isMultiRemove}
                    selectedEmptyGridText={selectedEmptyGridText}
                    updateSelectionFunction={updateSelectionFunction}
                    resolveInvertedFunction={resolveInvertedFunction}
                    disabled={disabled}
                    dataArray={dataArray}
                    dataArraySearchFields={dataArraySearchFields}
                    hideActions={hideActions}
                    rowRemovalCondition={rowRemovalCondition}
                    visibleRows={visibleRows}
                    disableCSVExport={disableCSVExport}
                    onAddAction={onAddAction}
                    dialogMaxWidth={dialogMaxWidth}
                    dialogFullWidth={dialogFullWidth}
                />
            )}
        />
    );
}
